import { CommonModule, NgOptimizedImage } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { NgArrayPipesModule, NgMathPipesModule } from 'ngx-pipes'

import { InformationFieldComponent } from '../../components/forms/information-field/information-field.component'
import { HasRolePipe } from '../../shared/pipes/has-role.pipe'
import { SharedModule } from '../../shared/shared.module'
import { NumericalInputComponent } from './components/numerical-input/numerical-input.component'
import { ProductCardComponent } from './components/product-card/product-card.component'
import { ProductCheckoutListComponent } from './components/product-checkout-list/product-checkout-list.component'
import { ProductsCheckoutComponent } from './pages/products-checkout.component'
import { ProductsPaymentComponent } from './pages/products-payment.component'
import { ProductsComponent } from './pages/products.component'
import { ProductRoutingModule } from './products-routing.module'

@NgModule({
  providers: [NumericalInputComponent],
  imports: [
    CommonModule,
    HasRolePipe,
    ProductRoutingModule,
    NgArrayPipesModule,
    FormsModule,
    NgOptimizedImage,
    NgMathPipesModule,
    SharedModule,
    InformationFieldComponent,
    ProductsComponent,
    ProductCardComponent,
    NumericalInputComponent,
    ProductsCheckoutComponent,
    ProductCheckoutListComponent,
    ProductsPaymentComponent,
  ],
  exports: [NumericalInputComponent],
})
export class ProductsModule {}
